<template>
<div>
    <Breadcrumbs main="Admin" title="Pledge Signing" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
     
                    
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </div>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                       

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :current-page="currentPage" :filter="filter" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    
                                    <template #cell(name)="data">
                                      <div v-if="data.item.name">
                                         <p> {{ data.item.name }}</p>
                                      </div>
                                    </template>
                                    <template #cell(institute_name)="data">
                                      <div v-if="data.item.institution_name">
                                         <p> {{ data.item.institution_name }}</p>
                                      </div>
                                    </template>
                                    <template #cell(email)="data">
                                      <div v-if="data.item.email">
                                         <p> {{ data.item.email }}</p>
                                      </div>
                                    </template>
                                
                                    <template #cell(action)="data">
                                            <feather type="eye" size="22px" style="color: #0E7459; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-details  @click="detailContent(data.item)" title="Details"></feather>
                                    </template>
                                
                                    
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Details Modal -->
    <b-modal id="modal-center-details" centered hide-header size="lg">
        <div class="mt-4 mb-4 font-weight-bold" style="font-size: large;">Pledge Details</div>

        <div class="row mb-3">
            <div class="col-sm-12 d-flex flex-column">
                <span class="font-weight-bold">Institution Name</span>
                <span>{{ contents.institution_name ? contents.institution_name : '-' }}</span>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Name</span>
                <span>{{ contents.name ? contents.name : '-' }} </span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Email</span>
                <span>{{ contents.email ? contents.email : '-' }}</span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Phone</span>
                <span>{{ contents.phone ? contents.phone : '-' }}</span>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Gender</span>
                <span class="text-capitalize">{{ contents.gender ? contents.gender : '-' }}</span>
            </div>
             <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Date of Birth</span>
                <span class="text-capitalize">{{ contents.date_of_birth ? contents.date_of_birth : '-' }}</span>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Pledge</span>
                <span class="text-capitalize">{{ contents.pledge }}</span>
            </div>
            
        </div>
        
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import js from '../../../auth/js';
import {
    myHost
} from '../../../_helpers/host'
import loader from '../loader/loader.vue'
export default {
    components: {
        loader,
    },
    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
            
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'institute_name',
                    label: 'Institution Name',
                    sortable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true
                },
             
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            filter: null,
            delete_value: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            contents:{
                id:'',
                name:'',
                institution_name:'',
                email:'',
                phone:'',
                date_of_birth: '',
                gender:'',
                pledge:'',

            }
        };
    },

    computed: {
        ...mapState({
            items: state => state.pledge.pledge,
            loading: state => state.pledge.pledgeLoading,
            error: state => state.pledge.pledgeError,
        }),

        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {

        this.$store.dispatch("pledge/fetchPledge").then(() => {
            this.totalRows = this.items.length;

        });

    },

    watch: {

    },

    methods: {
        detailContent(data){
            this.contents.id = data.id ? data.id : ''
            this.contents.name = data.name ? data.name : ''
            this.contents.institution_name = data.institution_name ? data.institution_name : ''
            this.contents.email = data.email ? data.email : ''
            this.contents.phone = data.phone ? data.phone : ''
            this.contents.date_of_birth = data.date_of_birth ? data.date_of_birth : ''
            this.contents.gender = data.gender ? data.gender : '',
            this.contents.pledge = data.pledge ? data.pledge : ''
        },
           
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        

    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
